import React, { Fragment, useEffect, useRef, useState } from 'react'
import ProgressBarStatusTracker from './ProgressBarStatusTracker'
import { useQuery } from '@apollo/client'
import { GET_ROUTE_POINT_BY_ID } from '../../../../../graphql/Catalog/Trucks/Routes/routesPoints'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import ProgressBarRoutes from './Helpers/ProgressBarRoutes'
import Loader from '../../../../Global/Spinner'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import Box from '../../../../Global/Box'
import { objNameRoles } from '../../../../../const/constRoles'
import InternalNotes from '../../../../Global/InternalNotes/InternalNotes'
const dataAttachmentTypeFile = {
  pdf: {
    icon: 'fas fa-file-pdf',
    text: 'PDF',
  },
  img: {
    icon: 'fas fa-image',
    text: 'IMG',
  },
}

const DetailsRoute = ({ routePointInfo, routePoint }) => {
  const boxScroll = useRef(null)

  const [countByStatus, setCountByStatus] = useState({
    total: 0,
    completed: 0,
    pending: 0,
  })
  const [empty, setEmpty] = useState(true)
  const [waterStation, setWaterStation] = useState('')
  const [destinations, setDestinations] = useState([])
  const [selectedCurrentPoint, setSelectedCurrentPoint] = useState(null)
  const [currentPointId, setCurrentPointId] = useState(null)

  const { loading, error, data } = useQuery(GET_ROUTE_POINT_BY_ID, {
    variables: {
      id: +currentPointId,
    },
    fetchPolicy: 'no-cache',
    skip: empty,
  })

  useEffect(() => {
    if (routePoint) {
      setCurrentPointId(routePoint.id)
      setEmpty(false)
    }
  }, [routePoint])

  useEffect(() => {
    try {
      if (loading) return
      if (error) throw error
      if (!data) return

      const { getRoutePointById } = data

      setSelectedCurrentPoint(getRoutePointById)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, loading, error])

  useEffect(() => {
    if (routePoint) return
    if (!routePointInfo) return

    let currentPoint = null
    let completed = 0
    let pending = 0
    let total = 0

    if (routePointInfo && routePointInfo.RouteToRoutePoints.length > 0)
      setEmpty(false)

    routePointInfo.RouteToRoutePoints.sort(
      (a, b) => a.water_truck_request_id - b.water_truck_request_id
    )

    if (routePointInfo.RoutesToStatus.name === 'Completado') {
      currentPoint = routePointInfo.RouteToRoutePoints[0].id
    }

    routePointInfo.RouteToRoutePoints.map((point) => {
      setWaterStation(point.RoutePointsToWaterStation.name)
      setDestinations((prev) => [...prev, point])

      if (
        point.RoutePointsToWaterTruckRequest.StatusOfWaterTruckRequest.name ===
        'Completado'
      ) {
        completed++
      }

      if (
        point.RoutePointsToWaterTruckRequest.StatusOfWaterTruckRequest.name !==
        'Completado'
      ) {
        pending++
      }

      if (
        point.RoutePointsToWaterTruckRequest.StatusOfWaterTruckRequest.name !==
          'Completado' &&
        !currentPoint
      ) {
        currentPoint = point.id
      }
      total++
    })

    setCountByStatus({
      total,
      completed,
      pending,
    })
    setCurrentPointId(currentPoint)
  }, [routePointInfo])

  useEffect(() => {
    if (routePoint) return
    if (boxScroll && boxScroll.current) {
      const element = boxScroll.current
      element.scrollTop = element.scrollHeight

      setTimeout(() => {
        const lists = element.querySelectorAll('li')
        lists.forEach((list) => {
          if (list.classList.contains('text-primary')) {
            list.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        })
      }, 300)
    }
  }, [boxScroll, waterStation, selectedCurrentPoint])

  return (
    <>
      {loading ? (
        <div className="d-flex align-items-center justify-content-center">
          <Loader />
        </div>
      ) : empty ? (
        <div className="d-flex align-items-center justify-content-center">
          <h5>Esta ruta no tiene asignado solicitudes de pipas</h5>
        </div>
      ) : (
        <div
          className="row p-4 mb-4"
          style={{
            borderBottom: '1px solid #e9ecef',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
          }}
        >
          {selectedCurrentPoint && (
            <div className="col-lg-6 mb-3 mb-lg-0 mt-2">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-primary">
                    <i className="fas fa-tint mr-2"></i>
                    <strong>Estación de agua:</strong>
                  </h5>
                  <p className="card-text lead">
                    {selectedCurrentPoint.RoutePointsToWaterStation.name}
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="col-lg-6">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title text-success">
                  <i className="fas fa-map-pin mr-2"></i>
                  <strong>
                    Destino:{' '}
                    {/* {routePointInfo && (
                    <ProgressBarRoutes completedPoints={5} totalPoints={10} />
                  )} */}
                  </strong>
                </h5>
                {routePoint && selectedCurrentPoint ? (
                  <>
                    <p className="card-text lead">
                      {
                        selectedCurrentPoint.RoutePointsToWaterTruckRequest
                          .AddressOfWaterTruckRequest.address_full
                      }
                    </p>
                  </>
                ) : (
                  <>
                    <div
                      className="timeLine-body"
                      ref={boxScroll}
                      style={{
                        maxHeight: '200px',
                        overflowY: 'auto',
                        width: '100%',
                      }}
                    >
                      <ul>
                        {destinations.map((destination, idx) => (
                          <li
                            key={idx}
                            onClick={() => setCurrentPointId(destination.id)}
                            className={`
                               ${
                                 currentPointId === destination.id
                                   ? 'text-primary'
                                   : destination.RoutePointsToWaterTruckRequest
                                       .StatusOfWaterTruckRequest.name ===
                                     'Completado'
                                   ? 'text-success'
                                   : 'text-secondary'
                               }
   
                                `}
                            style={{
                              cursor: 'pointer',
                            }}
                          >
                            {/* <p> */}
                            {
                              destination.RoutePointsToWaterTruckRequest
                                .AddressOfWaterTruckRequest.address_full
                            }
                            {/* </p> */}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          {selectedCurrentPoint && (
            <>
              <div className="col-lg-6 mt-2">
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title text-secondary">
                      <i className="fas fa-user mr-2"></i>
                      <strong>Información chofer:</strong>
                    </h5>
                    <p className="card-text lead">
                      {selectedCurrentPoint.RoutePointsToRoute.RouteToUser.name}{' '}
                      {
                        selectedCurrentPoint.RoutePointsToRoute.RouteToUser
                          .first_name
                      }
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mt-2">
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title text-secondary">
                      <i className="fas fa-truck mr-2"></i>
                      <strong>Información camión:</strong>
                    </h5>
                    <p className="card-text lead">
                      {
                        selectedCurrentPoint.RoutePointsToRoute.RouteToTrucks
                          .plate_number
                      }
                    </p>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* <div className="col-lg-4 mt-2">
          <div className="card h-100 shadow-sm">
            <div className="card-body">
              <h5 className="card-title text-secondary">
                <i className="fas fa-user-tie mr-2"></i>
                <strong>Proveedor:</strong>
              </h5>
              <p className="card-text lead"></p>
            </div>
          </div>
        </div> */}

          {selectedCurrentPoint && (
            <ProgressBarStatusTracker routePointInfo={selectedCurrentPoint} />
          )}

          <div className="col-12 row">
            <div className="col-lg-6">
              {selectedCurrentPoint &&
                selectedCurrentPoint.RoutePointsToWaterTruckRequest &&
                selectedCurrentPoint.RoutePointsToWaterTruckRequest
                  .AttachmentsOfWaterTruckRequest && (
                  <div className="col-12 mt-3">
                    <div className="card h-100 shadow-sm">
                      <div className="card-body">
                        <h5 className="card-title text-secondary">
                          {/* <i className="fas fa-clip mr-2"></i> */}
                          <i class="fas fa-link mr-2"></i>
                          <strong>Archivos adjuntos</strong>
                        </h5>

                        <div className="card-text lead mt-2">
                          <BoxAttachments
                            attachments={
                              selectedCurrentPoint
                                .RoutePointsToWaterTruckRequest
                                .AttachmentsOfWaterTruckRequest
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              {selectedCurrentPoint &&
                selectedCurrentPoint.RoutePointsToWaterTruckRequest &&
                selectedCurrentPoint.RoutePointsToWaterTruckRequest
                  .UserOfWaterTruckRequest && (
                  <div className="col-12 mt-3">
                    <div className="card h-100 shadow-sm">
                      <div className="card-body">
                        <h5 className="card-title text-secondary">
                          {/* <i className="fas fa-clip mr-2"></i> */}
                          <i class="fas fa-user mr-2"></i>
                          <strong>Datos solicitante</strong>
                        </h5>

                        <div className="card-text lead mt-2">
                          <BoxUserCreated
                            userCreated={
                              selectedCurrentPoint
                                .RoutePointsToWaterTruckRequest
                                .UserOfWaterTruckRequest
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
            {currentPointId && (
              <div className="col-6 col mt-3">
                <InternalNotes
                  category_note="water_truck_request"
                  document_id={currentPointId}
                  flagSwitchInternalMode={false}
                />
              </div>
            )}
          </div>

          {/* LINETIME */}

          {/* <div className="col-lg-12 mt-2">
          <div className="card h-100 shadow-sm">
            <div
              className="card-body"
              style={{
                marginRight: '100px',
                marginLeft: '100px',
              }}
            >
              <div className="row">
                <div className="col-lg-6">
                  {routePointInfo.infoPoint.loaded_at && (
                    <>
                      <p className="text-secondary">
                        <strong>Cargado el:</strong>{' '}

                      </p>
                      <p className="text-secondary">
                        <strong>Cargado en:</strong>{' '}

                      </p>
                      <p className="text-secondary">
                        <strong>Cantidad cargada:</strong>{' '}

                      </p>
                    </>
                  )}
                </div>
                <div
                  className="col-lg-6"
                  style={{
                    borderLeft: '1px solid #e9ecef',
                  }}
                >
                  {routePointInfo.infoPoint.delivered_at && (
                    <>
                      <p className="text-secondary">
                        <strong>Entregado el:</strong>{' '}
                        {moment(
                          Number(routePointInfo.infoPoint.delivered_at)
                        ).format('DD/MM/YYYY  HH:mm')}
                      </p>
                      <p className="text-secondary">
                        <strong>Entregado en:</strong>{' '}
                        {routePointInfo.infoRoute.address.address}
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div> */}
        </div>
      )}
    </>
  )
}

export default DetailsRoute

const BoxAttachments = ({ attachments, driverId }) => {
  const MySwal = withReactContent(Swal)

  const [grouped, setGrouped] = useState([])

  let imageWidth = 500
  let imageHeight = 440
  let flagKeepImageSize = false

  // Group attachments by user
  useEffect(() => {
    if (attachments && attachments?.length > 0) {
      const groupedAttachments = attachments.reduce((acc, attachment) => {
        const roleDriver = objNameRoles.chofer_pipas
        const roleId = attachment.UserOfWaterTruckRequestAttachment.id_role

        if (roleId === roleDriver) {
          acc.push({
            user_id: attachment.user_id_created,
            user: attachment.UserOfWaterTruckRequestAttachment,
            attachments: [attachment],
          })
        }
        //  else {
        //   acc[userIndex].attachments.push(attachment)
        // }
        return acc
      }, [])
      setGrouped(groupedAttachments)
    }
  }, [attachments])

  const switchFile = (type_file) => {
    return (
      <>
        {dataAttachmentTypeFile[type_file].text}
        <i className={`${dataAttachmentTypeFile[type_file].icon} fa-2x ml-2`} />
      </>
    )
  }

  const handleModalImage = (url) => {
    let resetImageSize = () => {
      imageWidth = 500
      imageHeight = 440
    }

    MySwal.fire({
      html: `
      <button id="increase-size-btn" class="btn btn-migrates" style="margin-bottom:10px;">
      Aumentar tamaño
      </button>
      <img src="${url}" style="display:block;margin:auto;width:${imageWidth}px;height:${imageHeight}px;" />
      `,
      didOpen: () => {
        const btn = document.getElementById('increase-size-btn')
        if (btn) {
          btn.onclick = () => {
            imageWidth = imageWidth + 300
            imageHeight = imageHeight + 300
            flagKeepImageSize = true
            MySwal.close()
            handleModalImage(url)
          }
        }
      },
      willClose: () => {
        if(!flagKeepImageSize)
          resetImageSize()
        else flagKeepImageSize = false
      },
      width: imageWidth + 40,
      heightAuto: false,
      customClass: {
        popup: '',
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
        footer: 'btn StandarModalFooterLogOut',
      },
      confirmButtonText: 'Aceptar',
    })
  }

  return (
    <Box
      // title={<TitleBox icon="fas fa-paperclip" text="Archivos adjuntos" />}
      classNameHeader="card-header py-1"
      withCard={false}
      content={
        <>
          {attachments?.length === 0 || grouped.length === 0 ? (
            'No hay archivos adjuntos'
          ) : (
            <div className="d-flex flex-wrap" style={{ gap: 10 }}>
              {grouped.map((item) => {
                return (
                  <Fragment key={item.user_id}>
                    <b style={{ width: '100%' }}>{`${item.user?.name} ${
                      item.user?.name && `(${item.user?.RoleOfUser?.role_name})`
                    }`}</b>

                    {item.attachments.map((attachment) => {
                      if (!attachment?.url) return null

                      return (
                        <div key={attachment.id} className="btn btn-light">
                          {attachment?.type_file === 'img' ? (
                            <a
                              className="link-primary documentLink"
                              style={{ textDecoration: 'none' }}
                              as="button"
                              title="Descargar"
                              onClick={() => handleModalImage(attachment.url)}
                            >
                              {switchFile(attachment?.type_file)}
                            </a>
                          ) : (
                            <a
                              className="link-primary documentLink"
                              style={{ textDecoration: 'none' }}
                              as="button"
                              href={attachment.url}
                              target="_blank"
                              rel="noreferrer"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Descargar"
                            >
                              {switchFile(attachment?.type_file)}
                            </a>
                          )}
                        </div>
                      )
                    })}
                  </Fragment>
                )
              })}
            </div>
          )}
        </>
      }
    />
  )
}

const BoxUserCreated = ({ userCreated }) => {
  // const title = <TitleBox icon="fas fa-user" text="Datos del solicitante" />

  if (!userCreated) {
    return (
      <Box
        // title={title}
        withCard={false}
        classNameHeader="card-header py-1"
        content={'No hay datos de usuario'}
      />
    )
  }

  const { name, first_name, last_name, email, phone } = userCreated

  return (
    <Box
      // title={title}
      withCard={false}
      classNameHeader="card-header py-1"
      content={
        <>
          <table className="table-reports-users">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Correo</th>
                <th>Teléfono</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {`${name ?? ''} ${first_name ? ' ' + first_name : ''} ${
                    last_name ? ' ' + last_name : ''
                  }
                  `}
                </td>
                <td>{email || 'N/A'}</td>
                <td>{phone || 'N/A'}</td>
              </tr>
            </tbody>
          </table>
        </>
      }
    />
  )
}
